import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { LoginComponent } from './components/login/login.component';
import { LayoutComponent } from './layout/layout.component';
import { EmailEditComponent } from './components/email/edit/email.edit.component';
import { PortalComponent } from './components/portal/portal.component';
import { PrincipalComponent } from './components/wizard/principal.component';

const routes: Routes = [
  { path: 'login', component: LoginComponent, data: { title: 'Login' } },  
  { path: 'login/:id', component: LoginComponent, data: { title: 'Login' } },  
  { path: 'l/:id', redirectTo: 'login/:id', pathMatch: 'full', data: { title: 'Login' } },  
  { path: '', redirectTo: '/app/home', pathMatch: 'full', data: { title: 'Portal Cobrança' } },
  { path: 'app', component: LayoutComponent, data: { title: 'Portal Cobrança' } },
  { path: '1', redirectTo: '/app/1', pathMatch: 'full', data: { title: 'Portal Cobrança' } },  
];

@NgModule({
    imports: [RouterModule.forRoot(routes)],
    exports: [RouterModule]
  })
  export class AppRoutingModule { }



// WEBPACK FOOTER //
// C:/Users/anderson.oshiro/Projetos/Azure/Ipcorp.PortalCobranca/Web/Ipcorp.PortalCobranca.Web/src/app/app-routing.module.ts